/**
 * Created by mac on 2/25/20
 */

const Map2dLocation = function () {
    cleverapps.EventEmitter.call(this);

    this.location = cleverapps.meta.getSelectedLocation();
    this.slot = this.location.slot;

    let isNewGame = false;

    if (this.location.locationConfig.isMain) {
        if (cleverapps.user.currentPhysicalLevel.level < 1 && !cleverapps.loadedSnapshot) {
            isNewGame = true;
        }
    } else if (this.slot.load("expedition") !== this.location.locationId) {
        isNewGame = true;
    }

    if (isNewGame) {
        if (cleverapps.unitsLibrary && !UnitsLibraryHelper.usesMainInstance(this.location.locationId) && !cleverapps.config.editorMode && !cleverapps.config.adminMode) {
            const openedCodes = Object.keys(cleverapps.unitsLibrary.opened).sort((a, b) => b.startsWith("adv3rp") - a.startsWith("adv3rp"));
            if (openedCodes.length > 0) {
                cleverapps.throwAsync(`isNewGame dirty library: location=${this.location.locationId} slotExpedition=${this.slot.load("expedition")} openedCodes=${openedCodes.slice(0, 10).join(",")}`);
            }
        }
        this.location.reset();
        this.location.setFirstSession(true);
    }

    if (cleverapps.travelBook) {
        const page = cleverapps.travelBook.getCurrentPage();
        page && page.setAttentionEvent(false);
    }

    Map2dLocation.currentLocation = this;

    cleverapps.config.saveUnitsEnabled = false;

    this.counter = new Counter();

    PseudoRandom.GET().randomSeed();

    this.onChangeWandsListener = function () {};
    this.onShowMergeBonus = function () {};

    const levelContent = bundles[this.location.locationConfig.locationBundleId].jsons.map_json.resolve().getJson();

    this.map = new Map2d(this.slot, levelContent.map, {
        tiles: this.location.meta.tiles,
        units: this.location.meta.units,
        families: this.location.families,
        visibleBox: levelContent.visibleBox,
        tilesVisibleRectFrame: levelContent.tilesVisibleRectFrame,
        regions: levelContent.regions,
        decorators: levelContent.decorators,
        terrains: levelContent.terrains,
        background: levelContent.background,
        field: levelContent.field
    });

    this.map.onUnitAvailableListener = this.onUnitAvailable.bind(this);
    this.map.onUnitFreshListener = this.onUnitFresh.bind(this);

    this.pocket = new Pocket(this.location.locationId);
    this.pocket.validate(this.location);

    const gameLevel = this.slot.load("gameLevel");
    if (gameLevel) {
        cleverapps.user.currentPhysicalLevel.level = gameLevel.value;
        cleverapps.exp.setExp(gameLevel.exp);
        cleverapps.user.save();
    }

    this.wands = this.slot.load("wands") || 0;
    if (this.wands < 0) {
        this.wands = 0;
    }

    this.harvested = new Harvested(this.slot);

    this.pushes = new Map2dPushes();
    this.setupMerge3();

    if (this.location.locationConfig.hasEnergyLottery) {
        this.energyLottery = new EnergyLottery(this.slot);
    }

    if (this.location.locationConfig.hasPawBox) {
        this.pawBox = new PawBox(this.slot);
    }

    if (!cleverapps.config.editorMode) {
        Quests.InitConfig(this.location);
        this.map.loadUnits();
        this.map.loadWorkers();

        this.quests = new Quests(this.slot);

        cleverapps.config.saveUnitsEnabled = true;

        this.map.loadFogs();

        this.loadStaticUnits();

        this.map.fogs.setWands(this.wands);
        this.map.fogs.on("takeWands", this.takeWands.bind(this), this);
        this.map.fogs.on("open", () => {
            this.counter.setTimeout(() => {}, 0);
        });
    } else {
        this.quests = new Quests(this.slot);
        Map2d.InsertDefaults(this.map, levelContent.field);

        cleverapps.config.saveUnitsEnabled = true;
    }
    this.setupMerge3Planners();
    this.removeUnitsInFog();

    this.map.customers.restoreCustomers();

    if (!this.map.getFocusCell()) {
        this.map.initFocusCell();
    }

    this.pushingComponent = new PushingComponent();

    this.thirdElementPlanner = new ThirdElementPlanner(this.slot);

    if (typeof IslandDecorationPlanner !== "undefined") {
        this.islandDecorationPlanner = new IslandDecorationPlanner();
    }

    this.unitStories = new UnitStories();
    if (typeof Landmarks !== "undefined") {
        this.landmarks = new Landmarks();
    }

    this.questsDataSource = new QuestsDataSource(this.quests);

    if (cleverapps.specialEnergyOffer) {
        cleverapps.specialEnergyOffer.init();
    }

    this.thirdElements = [];

    if (cleverapps.config.debugMode && !cleverapps.config.editorMode) {
        this.orangery = new Orangery(MergeOrangery);
    }

    if (cleverapps.config.debugMode) {
        LocationsClientValidator.validateDialogues(this.location);

        const referenceLocationBundleId = Map2dLocation.GetLocationReferenceBundleId(this.location.locationId);
        if (bundles[referenceLocationBundleId]) {
            cleverapps.bundleLoader.loadBundle(referenceLocationBundleId, {
                onSuccess: this.location.compareWithReferenceLocations.bind(this.location)
            });
        }
    }

    if (!cleverapps.config.adminMode && !cleverapps.config.editorMode) {
        this.counter.registerStage(-1, cleverapps.availableMove.pause.bind(cleverapps.availableMove, "game"));
        this.counter.registerStage(0, this.initStage.bind(this));
        this.counter.registerStage(1, this.map.customers.restoreCustomers.bind(this.map.customers));
        this.counter.registerStage(6, cleverapps.userStatus.reportUserAction.bind(cleverapps.userStatus));
        this.counter.registerStage(10, this.quests.finish.bind(this.quests));
        this.counter.registerStage(11, this.quests.showProgress.bind(this.quests));
        this.counter.registerStage(21, this.map.blockedGrounds.processFresh.bind(this.map.blockedGrounds));
        this.counter.registerStage(25, () => Spawner.processUpdate());
        this.counter.registerStage(26, this.unitStories.processFresh.bind(this.unitStories));
        this.registerMerge3Stages();
        this.counter.registerStage(40, this.quests.processFresh.bind(this.quests));
        this.counter.registerStage(41, this.map.fogs.calcFogStatesStage.bind(this.map.fogs));
        this.counter.registerStage(42, this.map.playCinematics.bind(this.map));
        this.counter.registerStage(43, this.thirdElementPlanner.spawnPending.bind(this.thirdElementPlanner));
        this.counter.registerStage(44, this.map.customers.process.bind(this.map.customers));
        if (this.landmarks) {
            this.counter.registerStage(48, this.landmarks.process.bind(this.landmarks));
        }
        if (this.pawBox) {
            this.counter.registerStage(55, this.pawBox.giveReward.bind(this.pawBox));
        }
        this.counter.registerStage(61, this.pocket.showHint.bind(this.pocket));
        this.counter.registerStage(62, this.harvested.showHint.bind(this.harvested));
        this.counter.registerStage(1001, () => {
            cleverapps.availableMove.resume("game");
        });

        this.map.counter.registerStage(0, () => {
            this.counter.trigger();
        });

        this.counter.registerStage(10000, cleverapps.tutorial.startNextStep.bind(cleverapps.tutorial), cleverapps.tutorial);
        this.counter.registerStage(10001, this.startTutorial.bind(this), this);
    }

    if (cleverapps.config.features.includes("game_level")) {
        this.counter.registerStage(20, cleverapps.gameLevel.checkLevelUp.bind(cleverapps.gameLevel));
        cleverapps.gameLevel.on("levelUp", this.onLevelUp.bind(this), this);
    }

    this.initMerge3();

    if (isNewGame && !this.location.locationConfig.isMain) {
        this.slot.save("expedition", this.location.locationId);
    }

    if (cleverapps.unitsShop) {
        cleverapps.unitsShop.runRefreshTimeouts();
    }
    cleverapps.offerManager.refreshAll();
    cleverapps.missionManager.updateMissionIcons();

    if (!cleverapps.config.adminMode && !cleverapps.config.editorMode) {
        this.counter.turnOff();
        this.updateAvailableUnits();
        this.counter.turnOn();
    }

    if (cleverapps.unitsShop && cleverapps.unitsShop.isAvailable()) {
        cleverapps.playSession.logEventOnce(cleverapps.EVENTS.UNITS_SHOP_AVAILABLE);
    }

    setTimeout(this.counter.trigger.bind(this.counter, undefined), 0);
};

Map2dLocation.prototype = Object.create(cleverapps.EventEmitter.prototype);
Map2dLocation.constructor = Map2dLocation;

Map2dLocation.prototype.startTutorial = function () {
    if (!cleverapps.tutorial.isActive() && !cleverapps.focusManager.isFocused() && cleverapps.Scenes.GetRunningScene().introShown) {
        cleverapps.tutorial.startScenario();
    }
};

Map2dLocation.prototype.isAllExpeditionsPassed = function () {
    if (!this.location.locationConfig.isMain || !cleverapps.achievements) {
        return false;
    }

    const allLandmarks = Object.values(Meta.GetAvailableLocations())
        .filter((loc) => loc.retire === false)
        .flatMap((loc) => AchievementsConfig.listByExpedition(loc.id));

    return allLandmarks.length > 0 && allLandmarks.every((config) => cleverapps.achievements.isGathered(config.id));
};

Map2dLocation.prototype.initStats = function () {
    const logFamily = function (type, progressEvent, completeEvent) {
        const current = cleverapps.unitsLibrary.getLastOpenCode(type);
        if (current) {
            const list = cleverapps.unitsLibrary.listCodesByType(type);
            const last = list[list.length - 1];

            let event = progressEvent + current;
            if (current === last && cleverapps.unitsLibrary.isOpened({ code: last, stage: Families[last].units.length - 1 })) {
                event = completeEvent;
            }
            cleverapps.metrics.logEvent(event);
        }
    };

    const logFamilies = function (resourceType, heroType, eventPref) {
        eventPref = eventPref || "";

        cleverapps.metrics.logEvent(eventPref + cleverapps.EVENTS.MERGE_START);
        logFamily(resourceType, eventPref + cleverapps.EVENTS.CURRENT_RESOURCE, eventPref + cleverapps.EVENTS.COMPLETE_RESOURCES);

        const currentHero = cleverapps.unitsLibrary.getCurrentHero(heroType);
        const heroEvent = currentHero ? (cleverapps.EVENTS.CURRENT_HERO + currentHero) : cleverapps.EVENTS.COMPLETE_HEROES;
        cleverapps.metrics.logEvent(eventPref + heroEvent);
    };

    const locationId = cleverapps.meta.selectedLocationId();
    cleverapps.playSession.logEventOnce(cleverapps.EVENTS.LOCATION.PLAYED, {
        location: locationId,
        key: cleverapps.EVENTS.LOCATION.PLAYED + locationId
    });

    Map2dLocation.LogDayOnce(locationId, cleverapps.EVENTS.LOCATION.DAY_PLAYED);
    cleverapps.meta.listActiveLocations().forEach((activeId) => Map2dLocation.LogDayOnce(activeId, cleverapps.EVENTS.LOCATION.DAY_ACTIVE));

    cleverapps.playSession.logAbtestEventOnce(cleverapps.EVENTS.LOCATION.PLAYED, {
        expedition: locationId,
        location: locationId,
        key: `ab-${cleverapps.EVENTS.LOCATION.PLAYED}${locationId}`
    });

    if (this.location.locationConfig.hasPawBox) {
        const logPets = function (prefix) {
            logFamily("clpet", prefix + cleverapps.EVENTS.CURRENT_PET, prefix + cleverapps.EVENTS.COMPLETE_PET);
            logFamily("clpetrare", prefix + cleverapps.EVENTS.CURRENT_PETRARE, prefix + cleverapps.EVENTS.COMPLETE_PETRARE);
            logFamily("clpetlegend", prefix + cleverapps.EVENTS.CURRENT_PETLEGEND, prefix + cleverapps.EVENTS.COMPLETE_PETLEGEND);
        };

        logPets("");

        if (cleverapps.paymentsHistory.isPayer()) {
            logPets("payer_");
        }

        const petsByType = {};
        Map2d.currentMap.listAvailableUnits([{ type: "clpet" }, { type: "clpetrare" }, { type: "clpetlegend" }]).forEach((pet) => {
            const type = pet.getType().replace("clpet", "");
            if (!petsByType[type]) {
                petsByType[type] = 0;
            }
            petsByType[type]++;
        });

        for (const type in petsByType) {
            cleverapps.playSession.logEvent(cleverapps.EVENTS.PET_RATE + type, { value: petsByType[type] });
        }
    }

    if (this.location.locationConfig.isMain) {
        logFamilies("resource", "hero");
        if (cleverapps.paymentsHistory.isPayer()) {
            logFamilies("resource", "hero", "payer_");
        }

        const resourceCodes = cleverapps.unitsLibrary.listCodesByType("resource");
        const lastResource = resourceCodes[resourceCodes.length - 1];
        if (lastResource && cleverapps.unitsLibrary.isOpened({ code: lastResource, stage: Families[lastResource].units.length - 1 })) {
            cleverapps.playSession.logEventOnce(cleverapps.EVENTS.PASS_ALL_LOCATIONS);
        }

        if (!cleverapps.unitsLibrary.getCurrentHero("hero")) {
            cleverapps.playSession.logEventOnce(cleverapps.EVENTS.PASS_ALL_HEROES);
        }

        if (this.isAllExpeditionsPassed()) {
            cleverapps.playSession.logEventOnce(cleverapps.EVENTS.PASS_ALL_EXPEDITIONS);
        }
    }
};

Map2dLocation.prototype.workersBusyHint = function (unit) {
    const locationConfig = cleverapps.meta.getSelectedLocation().locationConfig;

    if (!this.map.workers.isBonusWorkerBuyed() && !cleverapps.focusManager.isFocused() && locationConfig.usesWorkers && locationConfig.usesWorkers.bonusWorkers) {
        if (this.map.workers.isFreeWorkerAvailable()) {
            cleverapps.focusManager.display({
                focus: "BonusWorkerWindow",
                control: "MenuBarWorkersItem",
                actions: [
                    function (f) {
                        new ReceiveWorkerWindow();
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    },
                    function (f) {
                        const tutorial = cleverapps.clone(this.getMergeTutorial("free_worker"));

                        if (unit.findComponent(Buildable)) {
                            tutorial.steps[0].type = Map2d.START_BUILDING;
                        } else if (unit.findComponent(Mineable)) {
                            tutorial.steps[0].type = Map2d.START_MINING;
                        }

                        tutorial.steps[0].preferCell = { x: unit.x, y: unit.y };

                        this.tutorial.showTutorial(tutorial, f);
                    }.bind(this)
                ]
            });
            return;
        }

        if (!this.workersWindowShown || this.workersWindowShown < Date.now() - cleverapps.parseInterval(Map2dLocation.WORKERS_WINDOW_INTERVAL)) {
            cleverapps.focusManager.display({
                focus: "BonusWorkerWindow",
                control: ["MenuBarGoldItem", "MenuBarWorkersItem"],
                action: function (f) {
                    this.workersWindowShown = Date.now();
                    new BonusWorkerWindow();
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }.bind(this)
            });
            return;
        }
    }

    if (!Map2d.currentMap.workers.onlyOneWorkerAvailable()) {
        cleverapps.centerHint.createTextHint(Messages.get("Workers.busy"));
    }

    const worker = this.map.workers.findLeastBusy();
    if (worker) {
        this.map.focusOnUnit(worker.unit, {
            skipFocusReport: true
        });
        FingerView.hintTap({ x: worker.unit.x, y: worker.unit.y }, { runOnce: true });
    }
};

Map2dLocation.prototype.initStage = function () {
    if (this.initStageRunned) {
        return;
    }
    this.initStageRunned = true;

    this.map.fogs.initStage();

    this.initStats();

    this.map.initWorkers();
    if (this.map.pathIndicator) {
        this.map.pathIndicator.prePositionWorker();
    }
    this.restoreImportantUnits();
    this.restoreMultiCells();

    this.restoreKickOuts();
    this.checkReset();

    this.checkUnknownsInFog();

    this.updateExpedition();

    if (this.landmarks) {
        this.landmarks.restoreLandmarks();
    }
    this.initStageMerge3();
    cleverapps.eventBus.trigger("locationInitStage");

    this.map.listAvailableUnits().forEach((unit) => {
        if (unit.wantsSave) {
            unit.save();
            delete unit.wantsSave;
        }
    });
};

Map2dLocation.prototype.restoreImportantUnits = function () {
    if (cleverapps.gameModes.multipleHeroes) {
        return;
    }

    const fakeImportantUnits = [], playerImportantUnits = [];
    let x, y, unit;

    for (const row in this.map.fogs.fakeUnits) {
        for (const col in this.map.fogs.fakeUnits[row]) {
            x = parseInt(row);
            y = parseInt(col);
            if (this.map.fogs.getFakeUnit(x, y).important && !this.map.getFog(x, y)) {
                fakeImportantUnits.push({ x, y, fakeUnit: this.map.fogs.getFakeUnit(x, y) });
            }
        }
    }

    for (y = 0; y < this.map.getHeight(); y++) {
        for (x = 0; x < this.map.getWidth(); x++) {
            unit = this.map.getUnit(x, y);
            if (unit && unit.getData().important) {
                playerImportantUnits.push(unit);
            }
        }
    }

    const importantBubbles = !this.pocket ? [] : this.pocket.bubbles.filter((bubble) => Families[bubble.code].units[bubble.stage].important);

    fakeImportantUnits.forEach(function (fakeData) {
        let fakeUnit = fakeData.fakeUnit;
        x = fakeData.x;
        y = fakeData.y;

        let bestUnit = undefined, bestId = undefined;

        playerImportantUnits.forEach((playerUnit, id) => {
            if (playerUnit.code === fakeUnit.code) {
                if (!bestUnit || bestUnit.stage < playerUnit.stage || bestUnit.stage === playerUnit.stage && cc.pDistanceSQ(cc.p(x, y), bestUnit) > cc.pDistanceSQ(cc.p(x, y), playerUnit)) {
                    bestUnit = playerUnit;
                    bestId = id;
                }
            }
        });

        if (bestUnit) {
            playerImportantUnits.splice(bestId, 1);

            if (!bestUnit.isMovable() && (bestUnit.x !== x || bestUnit.y !== y)) {
                bestUnit.move(x, y);
            }
            return;
        }

        importantBubbles.forEach((bubble, id) => {
            if (bubble.code === fakeUnit.code) {
                if (!bestUnit || bestUnit.stage < bubble.stage) {
                    bestUnit = { code: bubble.code, stage: bubble.stage };
                    bestId = id;
                }
            }
        });

        if (bestUnit) {
            importantBubbles[bestId].remove();
            importantBubbles.splice(bestId, 1);
            fakeUnit = bestUnit;
        }

        if (Families[fakeUnit.code].units[fakeUnit.stage].climbable) {
            fakeUnit.stage = cleverapps.unitsLibrary.getLastOpenStage(fakeUnit.code) || 0;
        }

        unit = new Unit(fakeUnit);
        unit.move(x, y);
        this.map.onAddUnit(x, y, unit);
        if (!cleverapps.unitsLibrary.isOpened(unit)) {
            cleverapps.unitsLibrary.openUnit(unit);
        }

        cleverapps.metrics.logEvent(cleverapps.EVENTS.DEBUG.UNITS_RESTORE_IMPORTANT + this.location.locationId);

        const message = `important unit restored ${unit.code} ${unit.stage}`;

        if (cleverapps.config.debugMode) {
            throw new Error(message);
        } else {
            cleverapps.throwAsync({ group: "UnitsRestoreImportant", message });
        }
    }, this);

    importantBubbles.forEach((bubble) => {
        bubble.remove();
    });

    playerImportantUnits.forEach((playerUnit) => {
        playerUnit.remove();
    });
};

Map2dLocation.prototype.restoreMultiCells = function () {
    this.map.listAvailableUnits().forEach((unit) => {
        const multiCell = unit.findComponent(MultiCell);
        if (multiCell) {
            multiCell.restore();
        }
    });
};

Map2dLocation.prototype.loadStaticUnits = function () {
    for (let y = 0; y < this.map.groundMap.length; y++) {
        for (let x = 0; x < this.map.groundMap[y].length; x++) {
            if (this.map.isImpassableGround(x, y) && !this.map.getFog(x, y)) {
                const unit = this.map.getUnit(x, y);
                if (unit && unit.isMovable()) {
                    const empty = this.map.findEmptySlot(x, y);
                    if (empty) {
                        unit.move(empty.x, empty.y);
                    }
                }
            }
        }
    }
};

Map2dLocation.prototype.checkUnknownsInFog = function () {
    if (!this.map.fogs.blocks.fog0) {
        return;
    }

    let hasUnknownUnitsInFogs = false;

    this.map.listAvailableUnits((unit) => {
        if (unit.code === "unknown" && this.map.getFog(unit.x, unit.y)) {
            hasUnknownUnitsInFogs = true;
        }
    });

    if (hasUnknownUnitsInFogs) {
        cleverapps.metrics.logEvent(`${cleverapps.EVENTS.DEBUG.UNKNOWN_IN_FOG}-${cleverapps.meta.selectedLocationId()}`);
    }
};

Map2dLocation.prototype.updateExpedition = function () {
    if (!this.location.locationConfig.isMain) {
        this.location.resetPush();

        cleverapps.travelBook && cleverapps.travelBook.onUpdateExpedition();
    }
};

Map2dLocation.prototype.listIntroActions = function () {
    return [
        this.showScreen.bind(this),
        this.restoreProgressUpdate.bind(this),
        this.startIntroTutorial.bind(this),
        this.runFPS.bind(this),
        this.showFogErrorUnits.bind(this)
    ];
};

Map2dLocation.prototype.showFogErrorUnits = function (f) {
    const units = this.fogErrorUnits;
    if (!units || !units.length) {
        f();
        return;
    }

    const map = Map2d.currentMap;
    const mapView = map.getMapView();

    let minX = Infinity;
    let maxX = -Infinity;
    let minY = Infinity;
    let maxY = -Infinity;

    let left = Infinity;
    let right = -Infinity;
    let bottom = Infinity;
    let top = -Infinity;

    units.forEach(({ unit, message }) => {
        map.showTile(unit.x, unit.y);

        unit.highlight({ isErrorLight: true });

        const unitView = unit.onGetView();
        if (unitView) {
            unitView.replaceParentSamePlace(cleverapps.Scenes.GetMovingNode(unitView));
            unitView.sprite.setColor(cleverapps.styles.COLORS.COLOR_RED);
        }

        cleverapps.notification.create(message);

        minX = Math.min(minX, unit.x);
        maxX = Math.max(maxX, unit.x);
        minY = Math.min(minY, unit.y);
        maxY = Math.max(maxY, unit.y);

        const cell = mapView.getCell(unit.x, unit.y);
        left = Math.min(left, cell.x);
        right = Math.max(right, cell.x);
        bottom = Math.min(bottom, cell.y);
        top = Math.max(top, cell.y);
    });

    const center = {
        x: Math.round((minX + maxX) / 2),
        y: Math.round((minY + maxY) / 2)
    };
    map.showTile(center.x, center.y);

    const scrollView = map.scroller.getScrollView();
    const sceneSize = cleverapps.resolution.getSceneSize();
    const currentZoom = scrollView.zoom;

    let zoom = currentZoom;
    if (right > left && top > bottom) {
        const fit = Math.min(
            sceneSize.width * 0.85 / (right - left),
            sceneSize.height * 0.85 / (top - bottom)
        );
        zoom = Math.max(0.2, Math.min(currentZoom, fit));
    }

    scrollView.runAction(new cc.Sequence(
        new cc.ZoomAction(0.5, {
            zoom,
            zoomFocus: mapView.getCell(center.x, center.y)
        }),
        new cc.CallFunc(f)
    ));
};

Map2dLocation.prototype.restoreProgressUpdate = function (f) {
    cleverapps.restoreProgress.update();
    f();
};

Map2dLocation.prototype.runFPS = function (f) {
    levels.FPS.run(this.location.locationId, 0);
    f();
};

Map2dLocation.prototype.startIntroTutorial = function (f) {
    let actions = [];

    if (this.location.locationConfig.isMain) {
        cleverapps.silentIntro = false;

        const scenario = cleverapps.tutorial.findScenario(TutorialScenario.BASIC_TUTORIAL_NAME);
        if (scenario && scenario.isAvailable()) {
            actions = [
                function (f) {
                    cleverapps.tutorial.startScenario(scenario);
                    f();
                }
            ];
        } else {
            actions.push((f) => {
                if (this.map.fogs.blocks.fog0) {
                    this.map.fogs.blocks.fog0.unlock(f);
                } else {
                    f();
                }
            });
        }
    } else {
        cleverapps.silentIntro = false;

        const scenario = cleverapps.tutorial.findScenario(`${this.location.locationId}_tutorial`);
        if (scenario && scenario.isAvailable()) {
            actions = [
                (f) => {
                    cleverapps.tutorial.startScenario(scenario);
                    f();
                }
            ];
        } else if (this.map.fogs.blocks.fog0) {
            actions = [
                (f) => {
                    if (this.map.fogs.blocks.fog0) {
                        this.map.fogs.blocks.fog0.unlock(f);
                    } else {
                        f();
                    }
                },

                (f) => {
                    const tutorialData = this.getMergeTutorial(this.location.locationId);
                    if (tutorialData) {
                        this.tutorial.showTutorial(tutorialData, f);
                        this.map.fogs.calcFogStates();
                    } else {
                        f();
                    }
                }
            ];
        }
    }

    cleverapps.focusManager.compound(f, actions);
};

Map2dLocation.prototype.storeSave = function () {
    if (this.wands >= 0) {
        this.slot.save("wands", this.wands);
    }
};

Map2dLocation.prototype.stop = function () {
    this.counter.turnOff();

    levels.FPS.stop();

    runCleaners(this);

    cleverapps.userStatus.destructor();
    cleverapps.menuBar.stopItems();
    if (cleverapps.unitsShop) {
        cleverapps.unitsShop.stopRefreshTimeouts();
    }

    this.stopped = true;
    this.trigger("stop");
    this.purge();

    this.pushes.destructor();
    this.destroyMerge3();
    this.thirdElementPlanner.destructor();
    this.quests.destructor();
    this.unitStories.destructor();
    this.landmarks && this.landmarks.destructor();
    this.islandDecorationPlanner && this.islandDecorationPlanner.destructor();

    this.orangery && this.orangery.destructor();

    this.questsDataSource.destructor();

    this.pushingComponent.destructor();

    this.energyLottery && this.energyLottery.destructor();

    this.map.stop();

    InfoView.Clear();

    if (typeof UnitsShopTab !== "undefined") {
        UnitsShopTab.clearCardRewards();
    }

    // tmp - some units doesn't call destructor properly
    cleverapps.missionManager.trigger("erasePassPoints", this.map);
    cleverapps.missionManager.off("erasePassPoints");
};

Map2dLocation.prototype.onLevelUp = function () {
    cleverapps.focusManager.display({
        focus: "onLevelUp",
        control: ["MenuBarAvatarItem"],
        actions: [
            function (f) {
                new LevelUpWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            },

            function (f) {
                f();

                Map2d.currentMap.fogs.calcFogStates();
            },

            function (f) {
                const fakeUnit = Map2d.currentMap.fogs.findFakeUnit({ code: "warcraft" });

                if (!cleverapps.forces.isShown(Forces.FOG_EXPLORE) && fakeUnit && cleverapps.user.currentPhysicalLevel.level >= 17) {
                    Map2d.currentMap.exploreArea(fakeUnit, f);

                    cleverapps.forces.saveForce(Forces.FOG_EXPLORE);
                } else {
                    f();
                }
            },

            function (f) {
                if (cleverapps.platformLogic.reportLevelUp) {
                    cleverapps.platformLogic.reportLevelUp();
                }
                f();
            }
        ]
    });
};

Map2dLocation.prototype.setWands = function (wands, silent) {
    const oldWands = this.wands;
    this.wands = wands;

    if (!silent) {
        this.map.fogs.setWands(wands);
        this.onChangeWandsListener();
    }

    this.storeSave();

    if (wands > oldWands) {
        cleverapps.eventBus.trigger("collect_wands", wands - oldWands);
    }
};

Map2dLocation.prototype.takeWands = function (wands) {
    cleverapps.metrics.logEvent(cleverapps.EVENTS.SPEND_WANDS, { value: wands });
    this.setWands(this.wands - wands);
    this.storeSave();
};

Map2dLocation.prototype.replace = function (target, unit, silent) {
    if (target === this.map.dragging) {
        this.map.stopDragging();
    }

    if (!silent) {
        target.onDestruction();
        target.remove(true);

        Map2dLocation.currentLocation.spawn(unit, target, {
            radius: 0
        });
    } else {
        target.remove();

        unit = new Unit(unit);
        unit.setPosition(target.x, target.y);
        this.map.add(Map2d.LAYER_UNITS, unit.x, unit.y, unit);
        this.map.onAddUnit(unit.x, unit.y, unit);
        this.map.onUnitAvailable(unit);
        this.counter.setTimeout(Map2d.mapEvent.bind(this, Map2d.SPAWN, { unit }), 0);
        return unit;
    }
};

Map2dLocation.prototype.getUnitReplacer = function (unit) {
    return this.landmarks && this.landmarks.getDonorReplacer(unit) || { code: "coins", stage: Math.min(unit.stage, 3) };
};

Map2dLocation.prototype.needToReplaceWithCoins = function (unit) {
    if (cleverapps.gameModes.multipleHeroes) {
        return false;
    }

    if (Families[unit.code].units[unit.stage] && Families[unit.code].units[unit.stage].heroitem && cleverapps.unitsLibrary.isHeroAvailable(unit.code)) {
        return true;
    }

    if (unit.code === "kingfood" || unit.code === "dwarffood") {
        return true;
    }

    if (this.landmarks && this.landmarks.needToReplaceDonor(unit)) {
        return true;
    }

    return false;
};

Map2dLocation.prototype.replaceUnit = function (unitToReplace, replacer) {
    this.counter.setTimeout(() => {
        const family = Families[unitToReplace.code];
        const units = this.map.listAvailableUnits();
        const lastStageUnits = [];

        for (let i = 0; i < units.length; ++i) {
            const unit = units[i];

            if (unit.code === family.code && unit.stage === family.units.length - 1 && family.units[unit.stage].heroitem) {
                lastStageUnits.push(unit);
            } else if (["thirdelement", "t"].includes(unit.code) && unit.findComponent(ThirdElement).prize.code === family.code) {
                unit.remove();
            } else if (unit.code === family.code) {
                this.replace(unit, replacer(unit));
            } else if (unit.prizes && unit.prizes.length) {
                let prizes = unit.prizes.filter((prize) => prize.code !== family.code);

                if (unit.prizes.length !== prizes.length) {
                    if (prizes.length === 0) {
                        prizes = [{ code: "coins", stage: 0 }];
                    }
                    unit.setPrizes(prizes, unit.prizesExp);
                }
            }
        }

        if (lastStageUnits.length > 1) {
            const index = lastStageUnits.indexOf(unitToReplace);
            if (index !== -1) {
                const tmp = lastStageUnits[0];
                lastStageUnits[0] = lastStageUnits[index];
                lastStageUnits[index] = tmp;
            }

            for (let i = 0; i < lastStageUnits.length - 1; ++i) {
                this.replace(lastStageUnits[i], replacer(lastStageUnits[i]));
            }
        }
    }, 100);
};

Map2dLocation.prototype.playMergeSound = function (options) {
    const total = options.stage * options.amount;
    let level = 0;
    if (total >= 80) {
        level = 4;
    } else if (total >= 40) {
        level = 3;
    } else if (total >= 20) {
        level = 2;
    } else if (total >= 10) {
        level = 1;
    }
    cleverapps.effects.fire(`merge.effect.${level}`);
};

Map2dLocation.prototype.playMergeSoundCustom = function (unit) {
    const isNextStageOpened = cleverapps.unitsLibrary.isOpened({ code: unit.code, stage: unit.stage + 1 });

    const events = [];
    if (!isNextStageOpened) {
        events.push(`unit.merge.${unit.code}.first`);
    }
    events.push(`unit.merge.${unit.code}.${unit.stage + 1}`);
    events.push(`unit.merge.${unit.code}`);

    return Boolean(cleverapps.effects.fire(events));
};

Map2dLocation.prototype.axeTargets = function (units) {
    const directions = [{ x: 1, y: 0 }, { x: 0, y: 1 }, { x: -1, y: 0 }, { x: 0, y: -1 }];
    const cells = [];
    const used = {};
    const targets = [];
    const maxRadius = 6;
    const maxTargets = 3;

    units.forEach((unit) => {
        const cell = {
            x: unit.x,
            y: unit.y,
            unit
        };

        cells.push(cell);
        used[cell.x * 1000 + cell.y] = true;
    });

    for (let i = 0; i < cells.length && targets.length < maxTargets; ++i) {
        const origin = cells[i];

        for (let j = 0; j < directions.length && targets.length < maxTargets; ++j) {
            const delta = directions[j];
            const cell = {
                x: origin.x + delta.x,
                y: origin.y + delta.y,
                unit: origin.unit
            };

            if (used[cell.x * 1000 + cell.y]) {
                continue;
            }
            used[cell.x * 1000 + cell.y] = true;

            if (Math.abs(cell.x - cell.unit.x) > maxRadius || Math.abs(cell.y - cell.unit.y) > maxRadius) {
                continue;
            }

            cells.push(cell);

            const unit = this.map.getUnit(cell.x, cell.y);
            const isSource = unit && ["source", "hlsource", "drsource", "easource", "rpsource", "seasource", "advsource"].indexOf(Families[unit.code].type) !== -1;

            if (isSource) {
                targets.push({
                    target: unit,
                    origin: cell.unit
                });
            }
        }
    }

    return targets;
};

Map2dLocation.prototype.updateAvailableUnits = function () {
    this.map.listAvailableUnits().sort((a, b) => b.stage - a.stage).forEach(this.map.onUnitAvailable.bind(this.map));

    const reportOnce = cleverapps.once((message) => {
        cleverapps.throwAsync(message);
    });

    for (const col in this.map.fogs.fakeUnits) {
        for (const row in this.map.fogs.fakeUnits[col]) {
            const x = parseInt(col), y = parseInt(row);

            if (!cleverapps.isNumber(col) || !cleverapps.isNumber(row) || !this.map.fogs.fakeUnits[x] || !this.map.fogs.fakeUnits[x][y]) {
                reportOnce(`fakeUnit coordinate is not number - ${JSON.stringify({
                    col,
                    row,
                    x,
                    y
                })}`);
                continue;
            }

            const unit = this.map.fogs.fakeUnits[x][y].head || this.map.fogs.getFakeUnit(x, y);
            if (!this.map.getFog(x, y) && Families[unit.code] && Families[unit.code].type === "fruit") {
                cleverapps.unitsLibrary.openUnit(unit);
            }
        }
    }
};

Map2dLocation.prototype.onUnitAvailable = function (unit) {
    if (!Buildable.IsBuilt(unit)) {
        this.triggerBuildTutorial(unit);
        return;
    }

    if (!Creatable.IsCreated(unit)) {
        return;
    }

    let opened = false;

    if (cleverapps.unitsLibrary.openUnit(unit)) {
        opened = true;
    }

    if (this.needToReplaceWithCoins(unit)) {
        this.replaceUnit(unit, this.getUnitReplacer.bind(this));
    }

    if (unit.findComponent(HeroItem) && cleverapps.unitsLibrary.isHeroAvailable(unit.code)) {
        this.quests.finishQuestsByUnit(unit, Map2d.SPAWN);
        this.quests.finishQuestsByUnit(unit, Map2d.BUILD);
    }

    if (unit.findComponent(Customer)) {
        this.quests.finishQuestsByUnit(unit, Map2d.SPAWN);
    }

    if (unit.isLast() && unit.isBuilt()) {
        this.quests.finishQuestsByUnit(unit, Map2d.BUILD);
    }

    if (unit.findComponent(ResourceCollectible) || unit.findComponent(Upgradable)) {
        this.updatePulsing();
    }

    if (unit.getData().feedableTarget || unit.findComponent(Feedable)) {
        Feedable.processFeedable();
    }

    let cinematic = Climbable.CreateCinematic(unit);
    if (cinematic) {
        this.map.planCinematics(cinematic);
    }

    if (opened) {
        if (cleverapps.achievements) {
            cinematic = AchievementDonor.CreateCinematic(unit);
            if (cinematic) {
                this.map.planCinematics(cinematic);
            }
        }

        if (unit.isCastle() && cleverapps.unitsLibrary.listCodesByType("resource").every((code) => cleverapps.unitsLibrary.isOpened({ code, stage: Families[code].units.length - 1 }))) {
            cleverapps.metrics.logEvent(cleverapps.EVENTS.ALL_RESOURCE_LINES_COMPLETED);
        }

        cinematic = Map2dLocation.CreateTutorialCinematic(unit);
        if (cinematic) {
            this.map.planCinematics(cinematic);
        }

        this.map.fogs.wantsCalcFogStates = true;
        this.counter.setTimeout(() => {}, 0);
    }
};

Map2dLocation.prototype.onUnitFresh = function (unit) {
    if (cleverapps.aims.getTarget("unitsLibrary", { noDefault: true })
        && unit.isBuilt() && !cleverapps.gameModes.skipFlyToUnitsLibrary
        && !cleverapps.unitsLibrary.isOpened(unit) && !cleverapps.unitsLibrary.isHidden(unit)
        && !this.tutorial.isActive()
        && !cleverapps.tutorial.isActive()
    ) {
        unit.onShowFresh();
        this.counter.setTimeout(() => {}, 1700);
    }
};

Map2dLocation.prototype.updatePulsing = cleverapps.accumulate(0, function () {
    if (this.stopped) {
        return;
    }

    const upgradables = {};
    const resources = [];

    this.map.listAvailableUnits((unit) => {
        if (unit.isUpgradable() && unit.isBuilt()) {
            upgradables[unit.code] = true;
        }

        const resource = unit.findComponent(ResourceCollectible);
        if (resource) {
            resources.push(unit);
        }
    });

    resources.forEach((unit) => {
        const pulsing = unit.findComponent(Pulsing);
        if (pulsing) {
            pulsing.setActive(unit.isBuilt() && upgradables[pulsing.unit.code]);
        }
    });
});

Map2dLocation.prototype.showScreen = function (f, silent) {
    cleverapps.focusManager.compound(f, [
        (f) => cleverapps.timeouts.setTimeout(f, 100),
        function (f) {
            this.introZoom(f, silent);
        }.bind(this),
        function (f) {
            this.map.fogs.showBalloons(silent);
            if (this.map.pathIndicator) {
                this.map.pathIndicator.showTargetCell(true);
            }
            f();
        }.bind(this),
        Workers.ShowFinishedWorker,
        MiniGame.ProcessRewardsStage,
        function (f) {
            this.showUpFinished = true;
            this.map.onPositionChanged();
            f();
        }.bind(this)
    ]);
};

Map2dLocation.prototype.introZoom = function (f, silent) {
    if (silent) {
        f();
        return;
    }

    const scenario = cleverapps.tutorial.findScenario(TutorialScenario.BASIC_TUTORIAL_NAME);
    if (scenario && scenario.isAvailable()) {
        f();
        return;
    }

    const zoom = Map2dScroller.currentScroller.getBasicZoom();
    this.trigger("onAnimateZoom");
    cleverapps.Scenes.GetSceneComponent(Map2dLocationSceneComponent).animateZoom(zoom, 1, f);
};

Map2dLocation.prototype.collectAllUnits = function (f) {
    Object.keys(this.map.fogs.blocks).forEach(function (fogBlock) {
        this.map.fogs.blocks[fogBlock].trigger("updateState", FogBlock.NOTREADY, true);
    }, this);
    for (let y = 0; y < this.map.getHeight(); y++) {
        for (let x = 0; x < this.map.getWidth(); x++) {
            const unit = this.map.getUnit(x, y);
            if (unit && !unit.getData().important && !unit.head) {
                unit.components.forEach((component) => {
                    Object.keys(component).filter((fieldName) => component[fieldName] instanceof cleverapps.CountDown).forEach((timeoutFieldName) => {
                        component[timeoutFieldName].stop();
                    });
                });
                const collectible = unit.findComponent(Collectible);
                if (collectible && ["drfruit", "seafruit", "clfruit"].indexOf(unit.getType()) === -1) {
                    collectible.collect();
                }
            }
        }
    }
    f();
};

Map2dLocation.prototype.showLargestGroup = function (params) {
    const units = Map2d.currentMap.listAvailableUnits({ code: params.itemCode, stage: params.itemStage }).filter((unit) => !params.pointOfInterest || unit.getData().pointOfInterest);

    const fakeUnits = Map2d.currentMap.fogs.listFakeUnits({ code: params.itemCode, stage: params.itemStage }).filter((fakeUnit) => fakeUnit.pointOfInterest);

    if (units.length === 0 && fakeUnits.length === 0) {
        if (cleverapps.unitsLibrary.listTabCodes(cleverapps.meta.selectedLocationId()).indexOf(params.itemCode) === -1) {
            cleverapps.centerHint.createTextHint(params.text);
            return;
        }

        cleverapps.focusManager.display({
            focus: "largestGroupUnitsLibrary",
            action: function (f) {
                const searchUnit = { code: params.itemCode, stage: params.itemStage || 0 };

                if ((["hero", "drhero", "seahero",
                    "resource", "drresource", "searesource"].indexOf(Families[searchUnit.code].type) !== -1)) {
                    searchUnit.stage = Families[params.itemCode].units.length - 1;
                }

                new UnitsLibraryWindow(searchUnit);
                cleverapps.focusManager.onceNoWindowsListener = f;

                if (params.text) {
                    cleverapps.centerHint.createTextHint(params.text);
                }
            }
        });
        return;
    }

    units.forEach((unit) => {
        unit.highlight({ duration: 2 * Highlight.ONE_PULSE });
    });

    const target = units.length ? Map2d.currentMap.findLargestGroup(units)[0] : fakeUnits[0];
    Map2dScroller.currentScroller.zoomIn(target, {
        zoom: 1.35,
        callback: function () {}
    });
    Map2dScroller.currentScroller.cancelZoomOut();
    Map2d.currentMap.focusOnUnit(target, {
        skipFocusReport: true,
        visibleBox: {
            left: 0.1,
            right: 0.1,
            top: 0.1,
            bottom: 0.1
        },
        finger: params.finger
    });

    if (params.text) {
        cleverapps.centerHint.createTextHint(params.text);
    }
};

Map2dLocation.prototype.showNoSpaceHint = function (view, remains) {
    cleverapps.metrics.logEvent(cleverapps.EVENTS.NO_SPACE);
    if (remains.some((unit) => Unit.GetShape(unit).length > 1)) {
        cleverapps.centerHint.createTextHint(Messages.get("Spawn.nospace", { left: "2x2" }));
    } else {
        cleverapps.centerHint.createTextHint(Messages.get("Spawn.nospace", { left: remains.length }));
    }
};

Map2dLocation.prototype.merge = function (affected, unit, mergeInfoUnit) {
    const map = this.map;
    const counter = this.counter;

    this.counter.setTimeout(() => {}, 0);
    const affectedUnits = cleverapps.gameModes.automerge ? [] : [unit];

    affected.forEach((pos) => {
        const merging = map.getUnit(pos.x, pos.y);
        const worker = map.workers.findAssigned(merging);
        if (worker) {
            worker.clearAssignment();
        }
        merging.claimPoints();
        merging.onMerge(affected[0]);
        merging.remove(true);
        affectedUnits.push(merging);
    });

    const res = mergeInfoUnit.findComponent(MergeComponent).mergeBonus(affectedUnits.length);

    const worker = map.workers.findAssigned(unit);
    if (worker) {
        worker.clearAssignment();
    }
    unit.onMerge(affected[0]);
    unit.remove(true);

    cleverapps.eventBus.trigger("merge_units", affectedUnits.length, affected[0]);

    const resultUnits = [];

    for (let i = 0; i < res.bonus + res.keepLast; i++) {
        const newUnit = {
            code: mergeInfoUnit.code,
            stage: mergeInfoUnit.stage
        };

        if (i < res.bonus) {
            newUnit.unbuilt = !cleverapps.gameModes.skipBuildingStage;
            Object.assign(newUnit, mergeInfoUnit.getMergeUnit());
        }

        resultUnits.push(newUnit);
    }

    const newUnits = [];

    for (let i = 0; i < resultUnits.length; i++) {
        const pos = affected[i] || affected[affected.length - 1];
        let newUnit = resultUnits[i];

        const newPos = map.findEmptySlot(pos.x, pos.y, newUnit, {
            skipCheckScreen: true,
            skipCheckEqual: true
        });

        if (newPos) {
            newUnit = new Unit(newUnit);
            newUnit.setPosition(newPos.x, newPos.y);
            map.add(Map2d.LAYER_UNITS, newPos.x, newPos.y, newUnit);
            newUnits.push(newUnit);
        } else {
            this.pocket.addUnits(newUnit, pos);
        }
    }

    if (!newUnits.length) {
        return;
    }

    const baseSpawnDelay = 1000;
    const mergeDelay = baseSpawnDelay + 100 * newUnits.length;

    newUnits.forEach((newUnit, index) => {
        map.onAddUnit(newUnit.x, newUnit.y, newUnit);
        newUnit.setBlock(true);
        this.counter.setTimeout(() => newUnit.setBlock(false), mergeDelay);
        newUnit.didMerged(newUnits[0], index);
    });

    newUnits[0].onStartDidMerged();

    counter.setTimeout(() => {
        let sounded = false;
        if (cleverapps.config.name === "mergecraft" || cleverapps.config.debugMode) {
            sounded = this.playMergeSoundCustom(unit);
        }
        if (!sounded) {
            this.playMergeSound({
                amount: affectedUnits.length,
                stage: unit.stage
            });
        }
        map.onUnitFresh(newUnits[0]);
    }, 300);

    this.suggestOffer(newUnits);

    counter.setTimeout(() => {
        newUnits.forEach((newUnit, index) => {
            map.onUnitAvailable(newUnit);
            if (index < res.bonus) {
                const data = { unit: newUnit, affected: affectedUnits };
                Map2d.mapEvent(Map2d.SPAWN, data);
                cleverapps.tutorial.trigger(Map2d.SPAWN, data);
            }
        });

        cleverapps.effects.fire(`merge.effect.${unit.code}`);

        Map2d.mapEvent(Map2d.MERGE, { affected: affectedUnits });
    }, mergeDelay);

    if (res.next > 5 && res.next === 2 * affectedUnits.length - 1) {
        counter.setTimeout(() => {
            this.onShowMergeBonus(newUnits);
        }, 1000 + 100 * newUnits.length);
    }

    if (cleverapps.gameModes.axemerge) {
        const targets = this.axeTargets(newUnits);

        counter.setTimeout(() => {
            targets.forEach((tuple) => {
                tuple.target.onDestruction(false, tuple.origin);
            });
        }, 700);

        counter.setTimeout(() => {
            targets.forEach((tuple) => {
                tuple.target.remove(true);
                map.blockedGrounds.updateBlockedGrounds();
            });
        }, 1400);
    }

    cleverapps.tutorial.trigger("merge");

    if (Map2d.currentMap.advice) {
        Map2d.currentMap.advice.boo();
    }
};

Map2dLocation.prototype.spawn = function (units, parentUnit, options) {
    options = options || {};

    if (this.map.advice) {
        this.map.advice.boo();
    }

    const spawned = [];
    const remains = [];

    units = cleverapps.toArray(units) || [];

    if (units.length === 0 || cleverapps.config.editorMode) {
        return remains;
    }

    let parentCell = parentUnit;

    if (options.fromNode) {
        const mapView = this.map.getMapView();
        const pos = parentUnit.convertToWorldSpaceAR();
        parentCell = mapView.getCellByCoordinates(mapView.convertToNodeSpace(pos));
    }

    units.sort((a, b) => {
        if (a.code !== b.code) {
            if (a.code < b.code) {
                return -1;
            }
            return 1;
        }
        return a.stage - b.stage;
    });

    units = units.map((unit) => {
        if (this.needToReplaceWithCoins(unit) && unit.stage < Families[unit.code].units.length - 1) {
            return this.getUnitReplacer(unit);
        }
        return unit;
    });

    const targetCell = options.targetCell || {
        x: parentCell.x,
        y: parentCell.y
    };
    options.bound = parentUnit.bound;

    const expedition = cleverapps.meta.getSelectedLocation().locationConfig.isMain ? "main" : cleverapps.meta.selectedLocationId();
    const spawnSource = options.spawnSource || "";

    units.forEach((unit) => {
        if (remains.length) {
            remains.push(unit);
            return;
        }

        const cell = this.map.findEmptySlot(targetCell.x, targetCell.y, unit, options);
        if (!cell) {
            remains.push(unit);
            return;
        }

        unit = new Unit(unit);
        unit.setPosition(cell.x, cell.y);
        spawned.push(unit);

        if (["rubies", "coins", "wands", "energy"].includes(unit.code)) {
            cleverapps.metrics.logEvent(`${cleverapps.EVENTS.EARN.SPAWN}-${unit.code}${unit.stage}-${expedition}${spawnSource ? `_${spawnSource}` : ""}`);
        }
    });

    this.spawnAction(spawned, remains, parentUnit, options);

    return remains;
};

Map2dLocation.prototype.spawnAction = function (spawned, remains, parentUnit, options) {
    if (remains.length) {
        cleverapps.effects.fire("merge.spawn.fail");
        let target;
        if (options.fromNode) {
            target = parentUnit;
        } else {
            target = parentUnit.onGetView();
        }

        if (!options.useBubbleStack) {
            this.showNoSpaceHint(target, remains);
        }
    } else if (!options.noSound && !options.useBubbleStack) {
        cleverapps.effects.fire(options.effect || "merge.spawn.start");
    }

    const delay = options.delay || 100;
    const map = this.map;
    const counter = this.counter;

    spawned.forEach((unit) => unit.setBlock(true));

    counter.setTimeout(() => {
        if (!options.fromNode) {
            spawned.sort((a, b) => {
                let d1 = Math.sqrt((a.x - parentUnit.x) * (a.x - parentUnit.x) + (a.y - parentUnit.y) * (a.y - parentUnit.y));
                let d2 = Math.sqrt((b.x - parentUnit.x) * (b.x - parentUnit.x) + (b.y - parentUnit.y) * (b.y - parentUnit.y));
                if (d1 === 0) {
                    d1 = 10000;
                }
                if (d2 === 0) {
                    d2 = 10000;
                }
                return d1 - d2;
            });
        }
        spawned.forEach((unit, id) => {
            if (!unit.onGetView()) {
                map.onAddUnit(unit.x, unit.y, unit);
            }

            const pulsing = unit.findComponent(Pulsing);
            if (pulsing) {
                pulsing.beforeSpawn();
            }

            counter.playActions([
                (f) => {
                    unit.onSpawned(parentUnit, id, {
                        ...options,
                        callback: f
                    });
                },

                (f) => {
                    unit.setBlock(false);

                    map.onUnitAvailable(unit);

                    const data = {
                        unit,
                        affected: options.fromNode ? undefined : parentUnit
                    };
                    Map2d.mapEvent(Map2d.SPAWN, data);
                    cleverapps.tutorial.trigger(Map2d.SPAWN, data);

                    f();
                }
            ]);
        });
    }, delay);
};

Map2dLocation.prototype.confirmEnoughEnergy = function (energy) {
    if (cleverapps.lives.hasUnlimitedLives()) {
        return true;
    }

    if (cleverapps.lives.amount < energy) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.NO_ENERGY);

        if (cleverapps.flags.monetization === cleverapps.Flags.MONETIZATION_DISABLED && !(this.energyLottery && this.energyLottery.isReady())) {
            cleverapps.focusManager.display({
                focus: "restoreLives",
                action: function (f) {
                    new RewardWindow({ lives: cleverapps.lives.getMaxLives() - cleverapps.lives.amount });
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        } else {
            cleverapps.focusManager.display({
                focus: "buy_energy",
                control: ["MenuBarGoldItem", "MenuBarAvatarItem", "MenuBarLivesItem", "MenuBarCoinsItem"],
                action: function (f) {
                    new EnergyShopWindow();
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        }
        return false;
    }
    return true;
};

Map2dLocation.prototype.useEnergy = function (energy, unit) {
    if (!this.confirmEnoughEnergy(energy)) {
        return false;
    }

    cleverapps.metrics.logEvent(
        `${cleverapps.EVENTS.STATS.USE_ENERGY}-${cleverapps.meta.selectedLocationId()}`,
        { value: energy }
    );
    Map2dLocation.LogDay(cleverapps.meta.selectedLocationId(), cleverapps.EVENTS.LOCATION.DAY_ENERGY, { value: energy });

    if (!cleverapps.lives.hasUnlimitedLives()) {
        cleverapps.eventBus.trigger("useEnergy", unit);
        cleverapps.lives.setAmount(cleverapps.lives.amount - energy);
    }

    const activeMissions = Map2dLocation.UseEnergyMissions.filter((type) => this.location.locationConfig.isMain && cleverapps.missionManager.findRunningMission(type));

    activeMissions.forEach((missionType) => {
        const reward = new Reward("mission", { amount: energy, missionType });
        reward.collectRewardsAnimation(unit, { delay: 300, withoutDelta: true });
    });

    if (activeMissions.length === 0 && !unit.getData().simpleInfo) {
        const delta = -energy;
        cleverapps.aims.showDelta(delta, unit.onGetView(), {
            ...cleverapps.styles.UnitView.delta || {},
            type: "energy",
            icon: new Reward("energy", energy).getSmallIcon(),
            font: cleverapps.styles.FONTS.SCENE_ANIMATE_DELTA_TEXT,
            disableSummation: true
        });
    }

    return true;
};

Map2dLocation.prototype.addReward = function (type, amount, source, options) {
    options = options || {};
    options.event = options.event || cleverapps.EVENTS.EARN.OTHER;

    const reward = new Reward(type, amount, options);
    reward.receiveReward();
    reward.collectRewardsAnimation(source, options);
};

Map2dLocation.prototype.suggestOffer = function (newUnits) {
    let offerType;
    const p = 0.3;
    if (ThirdElement.IsAvailable(ThirdElement.TYPE_ADS, newUnits[0]) && Math.random() <= p) {
        offerType = ThirdElement.TYPE_ADS;
    } else if (ThirdElement.IsAvailable(ThirdElement.TYPE_RUBY, newUnits[0])) {
        offerType = ThirdElement.TYPE_RUBY;
    } else if (ThirdElement.IsAvailable(ThirdElement.TYPE_ANIMALS, newUnits[0])) {
        offerType = ThirdElement.TYPE_ANIMALS;
    }

    if (offerType) {
        this.thirdElementPlanner.planNext({
            type: offerType,
            delay: 2200,
            target: {
                code: newUnits[0].code,
                stage: newUnits[0].stage,
                x: newUnits[0].x,
                y: newUnits[0].y
            }
        });
    }

    return offerType;
};

Map2dLocation.prototype.setTimeout = function (callback, timeout) {
    return cleverapps.timeouts.setTimeout(() => {
        if (!this || this.stopped || this !== Map2dLocation.currentLocation) {
            return;
        }

        callback();
    }, timeout);
};

Map2dLocation.UseEnergyMissions = [Mission.TYPE_LIVESFEAST];

Map2dLocation.WORKERS_WINDOW_INTERVAL = "1 minute";
Map2dLocation.BASE_SPAWN_DELAY = 1000;

// the day of a scheduled location counted from its start, 1 on the first day
Map2dLocation.GetDay = function (locationId) {
    const schedule = cleverapps.meta.getLocationMeta(locationId).schedule;
    if (schedule && schedule.start <= Date.now() && Date.now() < schedule.finish) {
        return Math.floor((Date.now() - schedule.start) / cleverapps.parseInterval("1 day")) + 1;
    }
};

// one of the LOCATION.DAY_ events
Map2dLocation.LogDay = function (locationId, name, params) {
    const day = Map2dLocation.GetDay(locationId);
    if (day) {
        cleverapps.metrics.logEvent(name, { location: locationId, itemId: `${day}`, ...params });
    }
};

// once per player on a day of the location; a day of the player may cover two of them, hence the day in the key
Map2dLocation.LogDayOnce = function (locationId, name) {
    const day = Map2dLocation.GetDay(locationId);
    if (day) {
        cleverapps.playSession.logEventOnce(name, { location: locationId, itemId: `${day}`, key: `${name}_${locationId}_${day}` });
    }
};

cleverapps.whenAllInitialized(() => connector.payments.on("purchase", (result) => {
    if (result.purchase.type !== "subscription") {
        Map2dLocation.LogDay(cleverapps.meta.selectedLocationId(), cleverapps.EVENTS.LOCATION.DAY_PAYMENT, { value: result.purchase.realPrice });
    }
}));

Map2dLocation.GetLocationReferenceBundleId = function (locationId) {
    if (bundles[`location_${locationId}_ref`]) {
        return `location_${locationId}_ref`;
    }
    return "reference_locations";
};

Map2dLocation.CreateTutorialCinematic = function (unit) {
    if (!Map2dLocation.currentLocation) {
        return;
    }

    const tutorial = Map2dLocation.currentLocation.getMergeTutorial(`greeting_${Unit.GetKey(unit)}`);
    if (!tutorial) {
        return;
    }

    return function (f) {
        Map2dLocation.currentLocation.tutorial.showTutorial(tutorial, f);
    };
};

Map2dLocation.prototype.setupMerge3 = function () {
    this.tutorial = {
        isActive: function () {
            return false; 
        },
        showTutorial: function (data, f) {
            f(); 
        },
        processFresh: function () {},
        onShowHint: function () {},
        on: function () {},
        checkConditions: function () {
            return false; 
        },
        nextStep: function () {},
        destructor: function () {}
    };
};

Map2dLocation.prototype.setupMerge3Planners = function () {};

Map2dLocation.prototype.registerMerge3Stages = function () {};

Map2dLocation.prototype.initMerge3 = function () {};

Map2dLocation.prototype.initStageMerge3 = function () {};

Map2dLocation.prototype.destroyMerge3 = function () {};

Map2dLocation.prototype.getMergeTutorial = function () {
    return undefined;
};

Map2dLocation.prototype.triggerBuildTutorial = function () {};

Map2dLocation.prototype.removeUnitsInFog = function () {};

Map2dLocation.prototype.restoreKickOuts = function () {};

Map2dLocation.prototype.checkReset = function () {};

Map2dLocation.TUTORIALS = [];